import { NgModule } from '@angular/core';
import { NouisliderComponent } from './ng2-nouislider.component';

@NgModule({
  exports: [NouisliderComponent],
  declarations: [NouisliderComponent],
})
export class NouisliderModule {}
